import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { SERVICES } from "../../data/content";
import { openBooking } from "../../lib/booking";

const inr = (n) => `₹${Number(n).toLocaleString("en-IN")}`;

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="bg-ov-navy py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-8 mb-16 items-end">
          <div className="lg:col-span-8">
            <p className="font-body text-xs uppercase tracking-[0.2em] font-semibold text-ov-greenBright mb-6">
              Property Compliance Panel
            </p>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-white leading-tight tracking-tight">
              Complete property verification, <span className="italic text-ov-greenBright">before you buy.</span>
            </h2>
          </div>
          <div className="lg:col-span-4">
            <p className="font-body text-white/60 leading-relaxed">
              Nine rigorous compliance checks — from land survey to SARFAESI advisory. Transparent, service-based pricing.
            </p>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {SERVICES.map((s, i) => (
            <Reveal key={s.no} delay={(i % 3) * 0.08} className="bg-ov-navy">
              <button
                type="button"
                onClick={() => openBooking(s.title)}
                data-testid={`service-card-${s.no}`}
                className="group relative h-full w-full text-left p-8 bg-ov-navy hover:bg-ov-navyLight transition-colors duration-300"
              >
                <div className="flex items-start justify-between mb-8">
                  <span className="font-display text-2xl text-white/25 group-hover:text-ov-greenBright transition-colors duration-300">
                    {s.no}
                  </span>
                  <ArrowUpRight
                    size={20}
                    className="text-white/30 group-hover:text-ov-greenBright group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-300"
                  />
                </div>
                <h3 className="font-display text-xl md:text-2xl text-white leading-snug mb-3">{s.title}</h3>
                <p className="font-body text-sm text-white/55 leading-relaxed">{s.desc}</p>
                <div className="mt-6 flex items-center justify-between border-t border-white/10 pt-4">
                  <span className="font-display text-lg text-ov-greenBright" data-testid={`service-price-${s.no}`}>{inr(s.price)}</span>
                  <span className="font-body text-xs uppercase tracking-wider text-white/50 group-hover:text-ov-greenBright transition-colors">Book &amp; Pay</span>
                </div>
              </button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
